{
    "defaults": {
        "CoastalStates": [],
        "StateCoastal": [],
        "ShorelineCounties": [],
        "WatershedCounties": [],
        "CoastalWatershedStates": [],
        "ENOW": [
            "oceanEconomy",
            "selfEmployment"
        ],
        "OpenENOW": [
            "openEnow"
        ]
    },
    "regions": [
        {
            "id": "00000",
            "label": "Coastal US"
        },
        {
            "id": "-8",
            "label": "Great Lakes"
        },
        {
            "id": "-2",
            "label": "Gulf of Mexico"
        },
        {
            "id": "-4",
            "label": "Mid-Atlantic"
        },
        {
            "id": "-6",
            "label": "North Pacific"
        },
        {
            "id": "-5",
            "label": "Northeast"
        },
        {
            "id": "-7",
            "label": "Pacific"
        },
        {
            "id": "-3",
            "label": "Southeast"
        },
        {
            "id": "-1",
            "label": "West"
        },
        {
            "id": "-10",
            "label": "Pacific Islands"
        },
        {
            "id": "-9",
            "label": "Caribbean"
        }
    ]
}